<template>
  <section class="vote-detail--page">
    <div class="main">
      <myTitle :titleStyle="{color: '#fff', background: '#0F2C87'}" :titleName="'详情'"></myTitle>
      <div class="card-wrap">
        <div class="card-main">
          <div class="line1">当前排名：<span class="num">{{$route.query.rank}}</span></div>
          <div class="line2"></div>
          <div class="line-pic">
            <img v-if="detail.logo" :src="detail.logo" alt="">
            <div class="line-right">
              <div class="name">{{detail.name}}</div>
              <div class="num">编号：{{detail.id}}</div>
              <div class="num">当前票数：{{detail.votesNumbers}}</div>
            </div>
          </div>
          <template v-if="detail.details">
            <div class="line3">企业详情</div>
            <div class="line4" :class="moreFlag ? 'line-more' : ''">{{detail.details}}</div>
            <div class="line5" @click="handleMore">{{moreFlag ? '收起更多详情' : '查看更多详情'}}</div>
          </template>
        </div>
      </div>
      <div class="comment">
        <div class="comment-title">
          <span>评论区</span>
        </div>
        <nut-infiniteloading
          @loadmore="getCommentList"
          :is-show-mod="true"
          :has-more="!pageEnd"
          :is-loading="isLoading"
          :use-window="true"
          :threshold="20" class="list">
          <div class="new-comment" v-for="(item, index) in commentList" :key="index">
            <div class="comment-main">
              <img class="avator" :src="item.userPic" alt="">
              <div class="main-right">
                <div class="line">
                  <span class="name">{{item.userName}}</span>
                  <span class="time">({{item.releaseTime}})</span>
                  <i class="icon-delete iconfont" v-if="item.isYourself" style="margin-left: 12px;" @click="deleteComment(item.id)"></i>
                </div>
                <div class="content">
                  <div class="line">
                    {{item.comment}}
                  </div>
                  <div class="reply" v-if="item.answer">
                    <span class="title">回复：({{item.implementDate}})</span>
                    <span class="main">{{item.answer}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nut-infiniteloading>
      </div>
      <div class="bottom-wrap">
        <div class="bottom-main">
          <div class="share" @click="handleShare" v-if="loginFlag">
            <i class="icon-share iconfont"></i>
            <span class="text">分享</span>
          </div>
          <div class="comment-input">
            <!-- <input class="input-comment" @focus="focusFlag = true" @blur="focusFlag = false" v-model="commentValue" placeholder="评论一下" /> -->
            <input style="border-bottom: 1px solid #efefef; width: 100%;" class="input-comment" @focus="focusFlag = true" v-model="commentValue" placeholder="评论一下" />
            <img src="../assets/keybord.png" v-if="!focusFlag" alt="">
          </div>
          <div class="big-button" :class="focusFlag ? 'big-button-s' : ''">
            <div class="apply" v-if="focusFlag" :class="commentValue ? '' : 'gray'" @click="doComment">评论</div>
            <div class="rules" v-else @click="doVote">投票</div>
          </div>
          <div class="cancel" v-if="focusFlag" :class="commentValue ? '' : 'gray'"><i class="icon-close iconfont" @click="focusFlag = false"></i></div>
        </div>
      </div>
    </div>
    <nut-dialog title="提示" :visible="dialogShow" @ok-btn-click="dialogShow=false" cancelBtnTxt="关闭" :noOkBtn="true" @cancel-btn-click="dialogShow=false" @close="dialogShow=false">
      <div class="tip-main">投票或报名，请扫描二维码或点击下方链接，下载环保小智，在环保小智中进行操作</div>
      <img src="https://image.qsyhbgj.com/img-download-page.png" alt="">
      <a @click="$router.push('/h5download')" href="javascript:;" :noCancelBtn="true">或点击下载</a>
    </nut-dialog>
  </section>
</template>

<script>
/* eslint-disable no-undef */
import myTitle from '@/components/title'
import api from '../../api/index'
import xss from 'xss'
export default {
  data () {
    return {
      dialogShow: false,
      commentValue: '',
      focusFlag: false,
      value: '',
      moreFlag: false,
      loginFlag: Boolean(sessionStorage.getItem('qs_token')),
      detail: {},
      commentList: [],
      pageNo: 1,
      pageEnd: false,
      isLoading: false
    }
  },
  activated () {
    this.detail = {}
    this.getVoteDetail()
    this.getCommentList(true)
    this.$nextTick(() => {
      document.documentElement.scrollTop = 0
    })
    wx.updateAppMessageShareData({
      title: '', // 分享标题
      desc: '', // 分享描述
      link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: '', // 分享图标
      success: function () {
        // 设置成功
      }
    })
  },
  methods: {
    downloadTip () {
      if (!this.loginFlag) {
        this.dialogShow = true
        return true
      }
      return false
    },
    handleShare () {
      if (uni) {
        uni.postMessage({
          data: {
            type: 'iframeShare'
          }
        })
      } else {
        window.parent.postMessage({ type: 'iframeShare', path: `h5vote-detail?id=${this.$route.query.id}&rank=${this.$route.query.rank}` }, '*')
      }
    },
    getVoteDetail () {
      api.getVoteDetail({
        corporateId: this.$route.query.id
      }).then(res => {
        if (res.code === 200) {
          this.detail = res.data
          document.title = this.detail.name
        }
      })
    },
    doComment () {
      if (!this.commentValue) {
        this.$toast.text('请输入评论内容！')
        return
      }
      if (this.downloadTip()) return false
      api.voteComment({
        corporateId: this.$route.query.id,
        comment: xss(this.commentValue)
      }).then(res => {
        if (res.code === 200) {
          this.loading && this.loading.hide()
          this.focusFlag = false
          this.$toast.text(res.message || '评论成功', {
            duration: 1200
          })
        }
      })
    },
    doVote () {
      if (this.downloadTip()) return false
      this.loading = this.$toast.loading()
      api.doVote({
        corporateId: this.$route.query.id
      }).then(res => {
        this.loading && this.loading.hide()
        if (res.code === 200) {
          this.getVoteDetail()
          this.$toast.text('投票成功', {
            duration: 1200
          })
        } else {
          this.$toast.text(res.message, {
            duration: 1800
          })
        }
      })
    },
    handleMore () {
      this.moreFlag = !this.moreFlag
    },
    deleteComment (id) {
      if (this.downloadTip()) return false
      api.deleteVoteComment({
        commentId: id
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.text('删除成功')
          this.getCommentList(true)
        }
      })
    },
    getCommentList (refresh) {
      if (refresh) {
        this.pageNo = 1
        this.commentList = []
        this.pageEnd = false
      }
      this.isLoading = true
      api.getVoteComments({
        pages: 20,
        pageNo: this.pageNo,
        corporateId: this.$route.query.id ? this.$route.query.id : 1
      }).then(res => {
        this.isLoading = false
        if (res.code === 200) {
          this.pageNo++
          this.commentList = [...this.commentList, ...res.data.list]
          this.pageEnd = (this.commentList.length >= res.data.totalNumber) || (this.pageNo === 3)
        }
      })
    },
    showCommenBox () {}
  },
  components: {
    myTitle
  }
}
</script>

<style lang="scss">
.vote-detail--page {
  display: flex;
  flex-direction: column;
  background: #94A4A5 url('https://image.qsyhbgj.com/img-vote-bc.png') no-repeat;
  background-attachment: fixed;
  background-position: bottom;
  min-height: 100%;
  .main {
    background: #f4f5f6;
    padding-bottom: 58px;
    width: 7.5rem;
    margin: 0 auto;
    flex: 1;
    .card-wrap {
      background: #0F2C87;
      padding: 24px;
      .card-main {
        background: #fff;
        padding: 12px;
        border-radius: 4px;
        .line1 {
          text-align: center;
          .num {
            font-size: 24px;
            font-weight: bold;
            color: #d09319;
          }
        }
        .line2 {
          border-top: 1px dashed #efefef;
          margin: 8px 4px;
          position: relative;
          &::before {
            content: '';
            position: absolute;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            background: #0F2C87;
            left: -22px;
            top: -6px;
          }
          &::after {
            content: '';
            position: absolute;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            background: #0F2C87;
            right: -22px;
            top: -6px;
          }
        }
        .line-pic {
          display: flex;
          margin: 18px 0;
          img {
            width: 120px;
            object-fit: contain;
            height: 120px;
            flex: 0 0 120px;
            margin-right: 12px;
            border-radius: 4px;
          }
          .line-right {
            flex: 1;
            .name {
              font-size: 18px;
              font-weight: bold;
              color: #333;
            }
          }
        }
        .line3 {
          font-size: 16px;
          color: #333;
          border-left: 3px solid #0F2C87;
          padding-left: 12px;
          height: 12px;
          line-height: 12px;
          margin: 12px 0;
        }
        .line4 {
          text-indent: 2em;
          font-size: 14px;
          height: 21px;
          overflow: hidden;
          &.line-more {
            height: auto;
          }
        }
        .line5 {
          text-align: center;
          color: #0a2873;
          padding: 4px;
          cursor: pointer;
        }
      }
    }
    .comment {
      .comment-title {
        padding: 2px 8px;
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        margin-top: 12px;
        .comment-more {
          color: #409EFF;
        }
      }
      .new-comment {
        border-bottom: 1px solid #efefef;
        padding: 2px 8px;
        color: #333;
        .comment-main {
          flex: 1;
          display: flex;
          .avator {
            width: 28px;
            height: 28px;
            border-radius: 100px;
            border: 1px solid #efefef;
            margin-right: 12px;
            flex: 0 0 28px;
          }
          .main-right {
            display: flex;
            flex-direction: column;
            .line {
              font-size: 13px;
              display: flex;
              align-items: center;
              .name {
                font-size: 14px;
                margin-right: 4px;
              }
              .time {
                color: #83889a;
              }
              .uni-icon {
                color: #28354c;
                margin-left: 8px;
                font-weight: 500;
              }
            }
            .content {
              .reply {
                padding: 0 8px;
                display: flex;
                flex-direction: column;
                .line {
                  font-size: 13px;
                }
                .title {
                  color: #83889a;
                }
              }
            }
          }
        }
      }
      .comment-empty {
        text-align: center;
        color: rgb(119, 119, 119);
        &.comment-more {
          color: #0F2C87;
          cursor: pointer;
        }
      }
      .tips-txt {
        color: #83889a;
      }
    }
    .bottom-wrap {
      position: fixed;
      bottom: 0;
      left: 50%;
      width: 7.5rem;
      transform: translate(-50%);
      background: #fff;
      .bottom-main {
        display: flex;
        background: #fff;
        align-items: center;
        width: 7.5rem;
        margin: 0 auto;
        padding: 6px 12px;
        border-top: 1px solid #efefef;
        .share {
          display: flex;
          flex-direction: column;
          margin-right: 12px;
          .text {
            line-height: 1;
            margin-top: 2px;
            font-size: 12px;
          }
        }
        .comment-input {
          padding: 8px 0;
          flex: 1 0 25%;
          position: relative;
          .input-comment {
            input {
              height: 44px;
            }
          }
          img {
            position: absolute;
            right: 4px;
            top: 50%;
            transform: translateY(-50%);
            width: 28px;
          }
        }
        .big-button {
          flex: 1 0 45%;
          margin-left: 24px;
          display: flex;
          border-radius: 4px;
          overflow: hidden;
          cursor: pointer;
          &.big-button-s {
            flex: 0 0 20%;
          }
          .rules, .apply {
            flex: 1;
            text-align: center;
            line-height: 44px;
            height: 44px;
            color: #fff;
            &.gray {
              color: #fff;
              background: #666;
            }
          }
          .rules {
            background: linear-gradient(70deg,#eb934c,#d67946);
          }
          .apply {
            background: linear-gradient(70deg,#376dd6,#1b50b6);
          }
        }
        .cancel {
          margin-left: 12px;
        }
      }
    }
  }
  .nut-dialog-content {
    text-align: center;
    a {
      display: block;
    }
  }
}
</style>
